import { Button, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import classNames from 'classnames'
import React, { Component, ReactNode } from 'react'

import './hamburger-menu.scss'

type Props = {
  children: ReactNode
}

export class HamburgerMenu extends Component<Props> {
  state = {
    isHamburgerOpened: false,
  }

  render() {
    const { children } = this.props
    const { isHamburgerOpened } = this.state
    const hamburgerClassNames = classNames('hamburger', {
      'hamburger--open': isHamburgerOpened,
    })
    const hamburgerButtonClassNames = classNames('hamburger__button bp3-elevation-0', {
      'hamburger__button--open': isHamburgerOpened,
    })

    return (
      <>
        <div className={hamburgerButtonClassNames}>
          <Button
            className="bp3-minimal bp3-large"
            icon={
              <Icon
                icon={this.state.isHamburgerOpened ? IconNames.CROSS : IconNames.MENU}
                title={false}
                iconSize={this.state.isHamburgerOpened ? 20 : 16}
              />
            }
            onClick={this.toggleHamburgerMenu}
          />
        </div>
        <div className={hamburgerClassNames} onClick={this.toggleHamburgerMenu}>
          {children}
        </div>
        <div className="hamburger__overlay" onClick={this.toggleHamburgerMenu} />
      </>
    )
  }

  private toggleHamburgerMenu = () => {
    this.setState({ isHamburgerOpened: !this.state.isHamburgerOpened })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/hamburger-menu.tsx